import { Html, Svg } from "@react-three/drei";
import { useEffect, useState } from "react";
import { ARAnchor, ARView } from "react-three-mind";
import { TextureLoader } from "three";
import * as THREE from "three";

function Plane(props) {
  console.log("props: ", props.on);
  const loader = new TextureLoader();

  const materialTexture = loader.load("./card.png");
  materialTexture.encoding = THREE.sRGBEncoding;

  const materialTexture1 = loader.load("./card_back.png");
  materialTexture1.encoding = THREE.sRGBEncoding;

  const materialTexture2 = loader.load("./button1.png");
  materialTexture1.encoding = THREE.sRGBEncoding;

  useEffect(() => {
    console.log("props: ", props);
  }, [props]);

  if (props.on) {
    return (
      <group {...props} position={[0, 0, 0]}>
        <mesh
          geometry={new THREE.PlaneGeometry(1.2, 0.75)}
          material={
            new THREE.MeshBasicMaterial({
              map: materialTexture,
            })
          }
          onClick={() => window.alert("hellow")}
        />

        <mesh
          position={[0, -0.8, 0]}
          geometry={new THREE.PlaneGeometry(1.2, 0.75)}
          material={
            new THREE.MeshBasicMaterial({
              map: materialTexture1,
            })
          }
        />

        <Svg
          src={"/button1.svg"}
          position={[-0.5, 1, 0]}
          scale={0.004}
          rotateX={Math.PI}
          onClick={() => {
            window.open("https://virtustech.co.uk/contact", "_blank").focus();
          }}
        />
        {/* <Html>
          <div style={{ backgroundColor: "red" }}>test</div>
        </Html> */}
      </group>
    );
  } else {
    return undefined;
  }
}

function App() {
  const [on, setOn] = useState(false);

  function onAnchorFound() {
    setOn(true);
  }

  function onAnchorLost() {
    setOn(false);
  }

  return (
    <ARView
      imageTargets="./targets.mind"
      filterMinCF={0.0001}
      filterBeta={0.001}
      missTolerance={0}
      warmupTolerance={0}
    >
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <ARAnchor
        onAnchorFound={onAnchorFound}
        onAnchorLost={onAnchorLost}
        target={0}
      >
        <Plane on={on} />
      </ARAnchor>
    </ARView>
  );
}

export default App;
